import BillingDashboard from '@/models/general/settings/BillingDashboard';

const getDefaultState = () => ({
  smsCharges: [],
  viberCost: null,
  loading: false,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },

    setSmsCharges(state, payload) {
      state.smsCharges = payload;
    },

    setViberCost(state, payload) {
      state.viberCost = payload;
    },

    updateViberCostInState(state, payload) {
      state.viberCost = { ...state.viberCost, ...payload };
    },

    updateSmsChargeInState(state, payload) {
      const id = payload.country_id || payload.country_code;
      const idx = state.smsCharges.findIndex((x) => x.country_id === id || x.country_code === id);
      if (idx !== -1) {
        state.smsCharges.splice(idx, 1, { ...state.smsCharges[idx], ...payload });
      }
    },

    setLoading(state, payload) {
      state.loading = payload;
    },
  },

  actions: {
    async getSmsCharges({ commit }) {
      try {
        commit('setLoading', true, { root: false });
        commit('setSmsCharges', []);
        const { data } = await BillingDashboard.getSmsCharges();
        commit('setSmsCharges', data.data?.sms_country_costs || []);
      } catch (ex) {
        commit('setSmsCharges', []);
        commit('setErrorMessage', ex.response?.data.message, { root: true });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      } finally {
        commit('setLoading', false, { root: false });
      }
    },

    async getViberCost({ commit }) {
      try {
        commit('setLoading', true, { root: false });
        const { data } = await BillingDashboard.getViberCost();

        commit('setViberCost', data.data?.viber_cost || {});
        return data;
      } catch (ex) {
        commit('setViberCost', null);
        commit('setErrorMessage', ex.response?.data.message, { root: true });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        return ex.response?.data || {};
      } finally {
        commit('setLoading', false, { root: false });
      }
    },

    async updateSmsCharge({ commit }, { country_id, country_code, body }) {
      try {
        commit('setLoading', true, { root: false });
        const id = country_id || country_code;
        let data;

        if (body && Object.prototype.hasOwnProperty.call(body, 'cost')) {
          ({ data } = await BillingDashboard.updateSmsCountryCost(id, { sms_cost: body.cost }));
        } else if (body && Object.prototype.hasOwnProperty.call(body, 'enabled')) {
          ({ data } = await BillingDashboard.updateSmsCountryEnabled(id, {
            enabled: body.enabled,
          }));
        } else {
          throw new Error('Invalid body for updating SMS charge');
        }
        if (!data.error) {
          const payload = { country_id: id, ...body, ...data.data };
          commit('updateSmsChargeInState', payload);
        }
        return data;
      } catch (ex) {
        commit('setErrorMessage', ex.response?.data.message, { root: true });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        return ex.response?.data || {};
      } finally {
        commit('setLoading', false, { root: false });
      }
    },

    async bulkUpdateSmsEnabled({ commit }, body) {
      try {
        commit('setLoading', true, { root: false });
        const { data } = await BillingDashboard.updateAllSmsCountriesEnabled(body);
        return data;
      } catch (ex) {
        commit('setErrorMessage', ex.response?.data.message, { root: true });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        return ex.response?.data || {};
      } finally {
        commit('setLoading', false, { root: false });
      }
    },

    async updateViberCost({ commit }, body) {
      try {
        commit('setLoading', true, { root: false });
        const { data } = await BillingDashboard.updateViberCost(body);
        if (!data.error) {
          commit('updateViberCostInState', data.data?.viber_cost || {});
        }
        return data;
      } catch (ex) {
        commit('setErrorMessage', ex.response?.data.message, { root: true });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        return ex.response?.data || {};
      } finally {
        commit('setLoading', false, { root: false });
      }
    },
  },
};
